import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GroupInvoicePayload } from './generateInvoiceView.model';
import { NoteViewInterface, NoteInterface } from '../shared/interfaces/note.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  constructor(private httpClient: HttpClient) {}

  createNote(payload: NoteInterface): Observable<string> {
    const url = `${environment.apiHost}/Note`;

    return this.httpClient.post<string>(url, payload).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getAllServiceRequestLevelNote(businessUnitId: string, userBusinessUnitId: string): Observable<NoteViewInterface[]> {
    const url = `${environment.apiHost}/Note/FetchServiceRequestLevelNotes/${businessUnitId}/${userBusinessUnitId}`;

    return this.httpClient.get<NoteViewInterface[]>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getGroupNotes(serviceRequestId: GroupInvoicePayload, user: string): Observable<NoteViewInterface[]> {
    const url = `${environment.apiHost}/Note/FetchServiceRequestGroupNotes/${user}`;

    return this.httpClient
      .post<NoteViewInterface[]>(url, serviceRequestId)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  deleteNotes(noteId: string): Observable<unknown> {
    const url = `${environment.apiHost}/Note/${noteId}`;

    return this.httpClient.delete<unknown>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  notePriority(noteId: string, priority: boolean): Observable<unknown> {
    const url = `${environment.apiHost}/Note/${noteId}/${priority}`;

    return this.httpClient.put<unknown>(url, {}).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
